/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import { Container } from "react-bootstrap";

import Header from "./header";
import "./layout.scss";

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} />
      <main className="main">
        {/* <Container className="p-3">{children}</Container> */}
        <Container className="justify-content-md-center">{children}</Container>
      </main>
      {/* <footer className="footer mt-auto py-3 bg-dark text-white text-center"> */}
      <footer className="footer mt-auto py-3 bg-light text-black text-center">
        © {new Date().getFullYear()}{` `}<a href="https://juness.jp">JUNESS</a>
      </footer>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
